import {otsBaseApi} from "../../ots-api";
import {GeofenceSiteGroup} from "../../../model/geofence-site-group";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["GeofenceSiteGroups"]});

export const geofenceSiteGroupApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllGeofenceSiteGroups: builder.query<GeofenceSiteGroup[], string | undefined>({
      query: (regionId) => ({
        url: `/geofence-site-groups/all`,
        method: "GET",
        params: removeUndefined({
          regionId: regionId
        })
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "GeofenceSiteGroups", id} as const)),
            {type: "GeofenceSiteGroups", id: "LIST"}
          ];
        } else {
          return [{type: "GeofenceSiteGroups", id: "LIST"}];
        }
      }
    }),
    getGeofenceSiteGroup: builder.query<GeofenceSiteGroup, string>({
      query: (id) => ({
        url: `/geofence-site-groups/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "GeofenceSiteGroups", id}]
    }),
    createGeofenceSiteGroup: builder.mutation<GeofenceSiteGroup, Partial<GeofenceSiteGroup>>({
      query: (mapping) => ({
        url: "/geofence-site-groups",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "GeofenceSiteGroups", id: "LIST"}]
    }),
    updateGeofenceSiteGroup: builder.mutation<GeofenceSiteGroup, Partial<GeofenceSiteGroup>>({
      query: (mapping) => ({
        url: "/geofence-site-groups",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "GeofenceSiteGroups", id},
      ]
    }),
    deleteGeofenceSiteGroup: builder.mutation<void, Partial<GeofenceSiteGroup>>({
      query: (mapping) => ({
        url: "/geofence-site-groups",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "GeofenceSiteGroups", id}]
    })
  })
});

export const {
  useGetAllGeofenceSiteGroupsQuery,
  useGetGeofenceSiteGroupQuery,
  useCreateGeofenceSiteGroupMutation,
  useUpdateGeofenceSiteGroupMutation,
  useDeleteGeofenceSiteGroupMutation,
} = geofenceSiteGroupApi;
